function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M10 20v-5H5l-3-4.5L5 6h5V4L9 3h6l-1 1v2h5l3 4.5-3 4.5h-5v5h1v1H9v-1h1zM7 9h10v1H7V9zm1 2h8v1H8v-1z",
  fill: "currentColor",
  fillRule: "evenodd"
});

function SvgLocationTrailhead(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    ref: svgRef
  }, props), _ref);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationTrailhead);
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiB2ZXJzaW9uPSIxIj48ZyBzdHlsZT0iZmlsbC1ydWxlOmV2ZW5vZGQ7ZmlsbDpub25lO3N0cm9rZS13aWR0aDoxO3N0cm9rZTpub25lIj48ZyBmaWxsPSJjdXJyZW50Q29sb3IiPjxwYXRoIGQ9Ik0xMCAyMEwxMCAxNSA1IDE1IDIgMTAuNSA1IDYgMTAgNiAxMCA0IDkgMyAxNSAzIDE0IDQgMTQgNiAxOSA2IDIyIDEwLjUgMTkgMTUgMTQgMTUgMTQgMjAgMTUgMjAgMTUgMjEgOSAyMSA5IDIwIDEwIDIwWk03IDlMMTcgOSAxNyAxMCA3IDEwIDcgOVpNOCAxMUwxNiAxMSAxNiAxMiA4IDEyIDggMTFaIi8+PC9nPjwvZz48L3N2Zz4K";
export { ForwardRef as ReactComponent };